export default __webpack_public_path__ + "static/media/avatar-placeholder.6520ab81.png";